import { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { GeistProvider, CssBaseline, Toggle, Loading } from "@geist-ui/core";
import { darkTheme, lightTheme } from "./theme";
import useLocalStorage from "./hooks/useLocalStorage";
import { RouteProvider } from "./contexts/RouteContext";
import ConstructedRoutes from "./routes";

const App = () => {
  const [storedTheme, setStoredTheme] = useLocalStorage("theme", "solardark");

  const toggleTheme = () => {
    setStoredTheme(storedTheme === "solardark" ? "solarlight" : "solardark");
  };

  return (
    <RouteProvider>
      <GeistProvider themes={[darkTheme, lightTheme]} themeType={storedTheme}>
        <CssBaseline />
        <Toggle
          onChange={toggleTheme}
          style={{
            position: "absolute",
            top: "5px",
            right: "5px",
            zIndex: "100",
          }}
        />
        <Router>
          <Suspense fallback={<Loading />}>
            <div className="App">
              <Routes>
                <Route path="/" element={ConstructedRoutes["/"].element} />
                <Route
                  path="/projects"
                  element={ConstructedRoutes["/projects"].element}
                />
                <Route
                  path="/experience"
                  element={ConstructedRoutes["/experience"].element}
                />
                <Route
                  path="/blog"
                  element={ConstructedRoutes["/blog"].element}
                />
                <Route
                  path="/blog/:blogId"
                  element={ConstructedRoutes["/blog/:blogId"].element}
                />
              </Routes>
            </div>
          </Suspense>
        </Router>
      </GeistProvider>
    </RouteProvider>
  );
};

export default App;
